import { render, staticRenderFns } from "./ImportOffers.vue?vue&type=template&id=16121225&scoped=true"
import script from "./ImportOffers.vue?vue&type=script&lang=js"
export * from "./ImportOffers.vue?vue&type=script&lang=js"
import style0 from "./ImportOffers.vue?vue&type=style&index=0&id=16121225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16121225",
  null
  
)

export default component.exports